import React from 'react';
import { useForm } from 'react-hook-form';
import useEditCollection from '../../../../hooks/Collection/useEditCollection';

import FormError from '../../FormError';

const EditCollectionModal = ({ title, description, id }) => {
  const { register, handleSubmit, errors, reset } = useForm();
  const { editCollectionRequest } = useEditCollection(id, reset);

  const handleEdit = (data) => {
    editCollectionRequest.send(data.title, data.description);
  };

  return (
    <div
      className="modal fade"
      id="editCollectionModal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="createCollectionModal"
      aria-hidden="true"
    >
      <div
        className="modal-dialog modal-dialog-centered custom__modal__filter"
        role="document"
      >
        <div className="modal-content">
          <div className="custom__modal__content">
            <div className="custom__modal__header">
              <h5 className="custom__modal__title">Edit collection</h5>
              <a href="" className="custom__modal__close" data-dismiss="modal">
                <img src="/img/plus-icon.svg" alt="" />
              </a>
            </div>

            <div className="input__control mb-20">
              <input
                name="title"
                type="text"
                placeholder="Collection name"
                className="text-dark"
                defaultValue={title}
                ref={register({ required: true })}
              />
              {errors.title && <FormError text="required" />}
            </div>
            <div className="input__control mb-5">
              <textarea
                className="text-dark"
                name="description"
                placeholder="Collection description"
                rows="5"
                defaultValue={description}
                ref={register({ required: true })}
              />
              {errors.description && <FormError text="required" />}
            </div>
            <button
              href=""
              className="button button__turquoise"
              onClick={handleSubmit(handleEdit)}
              disabled={!!errors.title || !!errors.description}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditCollectionModal;
